import type { ReactNode } from "react";

export function Empty({ children }: { children: ReactNode }) {
  return <div className="px-3 py-6 text-center text-[12.5px] text-fg-faint">{children}</div>;
}
